import styled from 'styled-components';

import { FileTypeIcon } from '@/shared/components/FileTypeIcon';
import { COLORS } from '@/shared/constants/colors';

import { BFC } from '../types';

type FileTypeProps = { type: string };

export const FileType: BFC<FileTypeProps> = ({ type, ...props }) => {
  return (
    <Container {...props}>
      <FileTypeIcon type={type} size="s20" />
    </Container>
  );
};

const Container = styled.div`
  width: 28px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${COLORS.systemDark200};
  color: ${COLORS.systemLight100};
`;
